import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { CountryItem, LogisticService } from '../../../services/logistic.service';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-holiday',
  templateUrl: './holiday.component.html',
  styleUrls: ['./holiday.component.css']
})
export class HolidayComponent implements OnInit {
    public p2HoliDayKeyno;

    countryId;

    public edit?: Edit;

    public selectListCountries: CountryItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.p2HoliDayKeyno = this.stateService.getStateParams()['p2_holyday_keyno'];
        this.countryId = this.stateService.getStateParams()['country_id'];
    }

    private async loadEdit() {
        if (!!this.p2HoliDayKeyno && !!this.countryId) {
            this.edit = (await this.datatask.Post(569, {
                p2_holyday_keyno: this.p2HoliDayKeyno,
                country_id: this.countryId
            }))[0];
        }
    }

    private async loadCountries(): Promise<void> {
        this.selectListCountries = await this.logistic.getCountries();
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(570, this.edit))[0];

                if (response?.status_no === '0') {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(571, { p2_holyday_keyno: this.edit.p2_holyday_keyno }))[0];

                    if (response?.status_no === '0') {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadCountries();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    p2_holyday_keyno: number;
    systemdate: string;
    country_id: string;
    holyday_name: string;
}
